module.exports = __webpack_public_path__ + "media/offers_icons/budowlane-blue-2602b8b5.svg";